<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('lactate.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit">/{{$t('lactate.unit0')}}</div>
                <div class="chart-unit-right">{{$t('lactate.unit1')}}</div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="math-box">
            <div class="math-title">{{$t('lactate.type0')}}</div>
            <div class="math-row">
                <van-row>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{lactatePaceMath.max ? getLactatePace(lactatePaceMath.max) : '--'}}
                            </div>
                            <div class="math-text">{{$t('lactate.math0')}}</div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{lactatePaceMath.min ? getLactatePace(lactatePaceMath.min) : '--'}}
                            </div>
                            <div class="math-text">{{$t('lactate.math1')}}</div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{lactatePaceMath.avg ? getLactatePace(lactatePaceMath.avg) : '--'}}
                            </div>
                            <div class="math-text">{{$t('lactate.math2')}}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="math-box">
            <div class="math-title">{{$t('lactate.type1')}}</div>
            <div class="math-row">
                <van-row>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{lactateHrMath.max ? lactateHrMath.max : '--'}}</div>
                            <div class="math-text">{{$t('lactate.math0')}}</div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{lactateHrMath.min ? lactateHrMath.min : '--'}}</div>
                            <div class="math-text">{{$t('lactate.math1')}}</div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{lactateHrMath.avg ? lactateHrMath.avg : '--'}}</div>
                            <div class="math-text">{{$t('lactate.math2')}}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="desc-box">
            <div class="desc-title">{{$t('lactate.descTitle')}}</div>
            <div class="desc-info desc-last">
                <div class="desc-sub-title">{{$t('lactate.type0')}}：</div>
                {{$t('lactate.desc0')}}
                <div class="desc-sub-title">{{$t('lactate.type1')}}：</div>
                {{$t('lactate.desc1')}}
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'lactate',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 0,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                wNum: 0,
                mNum: 0,
                showTimeBox: false,
                info: {},
                lactatePaceMath: {},
                lactateHrMath: {},
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('lactate.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            timeRight() {
                if (this.activeTime == 0 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 0) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 1) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            getData() {
                this.checkOpacity();
                this.$api.status.queryLactate({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.info = res.info;
                        this.lactatePaceMath = res.info.lactatePaceMath;
                        this.lactateHrMath = res.info.lactateHrMath;
                        this.info.dateArr = [];
                        this.info.dataPaceArr = [];
                        this.info.dataHrArr = [];
                        for (let i = 0; i < this.info.data.length; i++) {
                            this.info.dateArr.push(this.info.data[i].date);
                            this.info.dataPaceArr.push(this.info.data[i].lactatePace);
                            this.info.dataHrArr.push(this.info.data[i].lactateHr);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            },
            getAgeColor(age, fitnessAge) {
                let color;
                if (fitnessAge < age) {
                    color = getSkin('--chart-color-8');
                } else if (fitnessAge == age) {
                    color = getSkin('--chart-color-1');
                } else {
                    color = getSkin('--chart-color-3');
                }
                return color;
            },
            drawChart() {
                let maxa = Math.max.apply(null, this.info.dataHrArr)
                let maxb = Math.max.apply(null, this.info.dataPaceArr)
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                let _this = this;
                if (!this.lactatePaceMath.avg) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 41 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 49 * this.ratio,
                            right: 45 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.info.dateArr
                        },
                        yAxis: [{
                            type: 'value',
                            position: 'right',
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            },
                            splitNumber: 4,
                        }, {
                            type: 'value',
                            position: 'left',
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return _this.getLactatePace(value)
                                },
                                showMinLabel: false
                            },
                            splitNumber: 4,
                        }],
                        series: [
                            {
                                name: this.$t('lactate.type1'),
                                type: 'bar',
                                showSymbol: false,
                                data: [0, 0, 0],
                                itemStyle: {
                                    width: 2,
                                    color: getSkin('--chart-color-3')
                                }
                            }, {
                                name: this.$t('lactate.type0'),
                                type: 'bar',
                                showSymbol: false,
                                yAxisIndex: 1,
                                data: [0, 0, 0],
                                itemStyle: {
                                    width: 2,
                                    color: getSkin('--chart-color-8')
                                }
                            }
                        ]
                    }, true);
                } else {
                    this.myChart.setOption({
                        grid: {
                            top: 41 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 49 * this.ratio,
                            right: 45 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0] - size.contentSize[0] / 2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth) {
                                    x = cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let pace = params[1].value;
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                                html += '<div style="font-family:D-D";font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ' + _this.$t('lactate.type1') + '</div>'
                                html += '<div style="font-family:D-D";font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + _this.getLactatePace(pace) + '</span> ' + _this.$t('lactate.type0') + '</div>'
                                return html
                            }
                        },
                        yAxis: [{
                            type: 'value',
                            position: 'right',
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            },
                            max: this.set_max(maxa),
                            interval: this.set_max(maxa) / 4,
                        }, {
                            type: 'value',
                            position: 'left',
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return _this.getLactatePace(value)
                                }
                            },
                            max: this.set_max(maxb),
                            interval: this.set_max(maxb) / 4,
                        }],
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.info.dateArr
                        },
                        series: [
                            {
                                name: this.$t('lactate.type1'),
                                type: 'line',
                                showSymbol: false,
                                data: this.info.dataHrArr,
                                itemStyle: {
                                    width: 2,
                                    color: getSkin('--chart-color-3')
                                }
                            }, {
                                name: this.$t('lactate.type0'),
                                type: 'line',
                                showSymbol: false,
                                yAxisIndex: 1,
                                data: this.info.dataPaceArr,
                                itemStyle: {
                                    width: 2,
                                    color: getSkin('--chart-color-8')
                                }
                            }
                        ]
                    }, true)
                }
            },
            //  取最大值
            set_max(num) {
                // 1.判断是否小数：  //判断是否含有小数点：要检索的字符串值没有出现，则该方法返回 -1。
                if (num.toString().indexOf(".") != -1) {//有小数点
                    num = Math.ceil(num);//向上取整
                }
                // 2.向上取整数倍
                if (num.toString().length < 2) {
                    // 一位数1
                    num = 10;
                } else if (num.toString().length < 3) {
                    // 2位数
                    num = Math.ceil(num / 4) * 4;// 变成最近的5的倍数
                } else {
                    // 位数--先判断是不是1000...的倍数
                    var t = '';
                    for (let i = 0; i < num.toString().length - 1; i++) {
                        t += '0';//'0000...'
                    }
                    if ((num % Number(1 + t)) != 0) {//不是100的倍数

                        num = (Number(num.toString().substr(0, 1)) + 1) * Number(1 + t);
                    }
                }
                return num
            },
            // 乳酸阈配速
            getLactatePace(num) {
                if (num == null || num == '- - ') return '- - ';
                let m = Math.floor(num / 60);
                let s = parseInt(num % 60);
                return m + "'" + s + "''"
            },
        }
    }
</script>

<style scoped>

    #chart-box {
        height: 204px;
        width: 100%;
    }

    .chart-unit {
        position: absolute;
        font-size: 12px;
        color: var(--text-color-3);
        left: 12px;
        top: 24px;
    }

    .chart-unit-right {
        position: absolute;
        font-size: 12px;
        color: var(--text-color-3);
        right: 8px;
        top: 24px;
    }

    .math-box {
        width: 345px;
        height: 96px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 10px auto;
        position: relative;
    }

    .math-title {
        width: 79px;
        height: 24px;
        background: var(--bg-color-1);
        border-radius: 5px 5px 5px 5px;
        position: absolute;
        top: 14px;
        left: 9px;
        color: var(--text-color-1);
        font-size: 13px;
        text-align: center;
        line-height: 24px;
    }

    .math-row {
        position: absolute;
        top: 33px;
        width: 100%;
    }

    .desc-sub-title {
        color: var(--text-color-1);
    }

    .time-box {
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/views/status/15lactate.vue